const intialState = [];

export default function reducer(state=intialState, action){

    switch (action.type){

        case "GET_PERSPECTIVES_FULFILLED":{
            return action.payload.data

        }
        default: {
            return state;
        }
    }
};


// WEBPACK FOOTER //
// ./src/reducers/entreprise/perspectives.js